import { useEffect, useState } from "react";

import { DepartmentItem, SearchConditionItem } from "@/types/setting";

import {
  AddGroup,
  DeleteGroup,
  GetUserDepartmentList,
  SetSearchCondition,
  UpdateGroup,
} from "@/services/Setting";

import { isNotEmpty } from "@/libs/utils";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CommonImg from "@/components/Common/Img";
import CommonDialogDepartmentItem from "@/components/CommonDialogDepartmentItem";

import CogWheelIcon from "@/assets/images/cogwheel-icon.png";
import BlackPlusIcon from "@/assets/images/black-plus-icon.png";

type Props = {
  onReload: () => void;
};
export default function DialogMemberDepartment({ onReload }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [holdDelete, setHoldDelete] = useState<boolean>(false);
  const [departmentList, setDepartmentList] = useState<DepartmentItem[]>([]);

  const handleChangeGroup = async (groupIndex: number, groupId?: string) => {
    const api = groupId ? UpdateGroup : AddGroup;
    const groupName = departmentList[groupIndex].group_name;
    const params = `group_name="${groupName}"${isNotEmpty(groupId) ? `, group_id="${groupId}"` : ``}`;
    try {
      const result = await api(params);
      if (result.data.success) {
        onLoad();
      }
    } catch (e) {
    } finally {
    }
  };

  const handleDeleteGroup = async (groupId: string, groupIndex?: number) => {
    if (!isNotEmpty(groupId)) {
      setDepartmentList((prev) =>
        prev.filter((_, index) => index !== groupIndex)
      );
      return;
    }
    try {
      const params = `group_id="${groupId}"`;
      const result = await DeleteGroup(params);
      if (result.data.success) {
        onLoad();
      }
    } catch (e) {
    } finally {
    }
  };

  const onLoad = async () => {
    try {
      const result = await GetUserDepartmentList();
      setDepartmentList(result.data.pods[0].content);
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (!open) {
      onReload();
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <CommonImg
          src={CogWheelIcon}
          alt={"Cog Wheel"}
          className={"size-[28px]"}
        />
      </DialogTrigger>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>멤버 소속 관리</DialogTitle>
        </DialogHeader>
        <DialogDescription />
        <div className="flex flex-col gap-[16px]">
          <div className="h-[430px] overflow-auto flex flex-col gap-[8px]">
            {departmentList.map((item, itemIndex) => (
              <CommonDialogDepartmentItem
                key={itemIndex}
                itemIndex={itemIndex}
                item={item}
                setItem={setDepartmentList}
                itemListLength={departmentList.length}
                holdDelete={holdDelete}
                onChangeTitle={(groupIndex, groupId) => {
                  handleChangeGroup(groupIndex, groupId);
                }}
                onChangeHoldDelete={(value: boolean) => {
                  setHoldDelete(value);
                }}
                onDelete={(groupId) => {
                  handleDeleteGroup(groupId, itemIndex);
                }}
              />
            ))}
          </div>
          <div className="flex justify-center">
            <CommonImg
              src={BlackPlusIcon}
              alt="Plus"
              className="size-[24px] cursor-pointer"
              onClick={() => {
                setDepartmentList((prev) => [
                  ...prev,
                  {
                    group_name: "",
                  } as DepartmentItem,
                ]);
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
